export default "__VITE_ASSET__DvPPufXY__"